import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react";
import CardDropdown from "components/common/CardDropdown";
import React, { useCallback, useRef, useState } from "react";
import { Button, Dropdown, Form, Modal } from "react-bootstrap";
import { MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import "../../styles.css"; // Custom styles for the component

const WeighmentEntryModal = ({ setIsOpenModal, isOpenModal, from }) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setIsOpenModal(false);
  };

  const navigate = useNavigate();
  const columnApiRef = useRef();
  const gridRef = useRef();

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs] = useState([
    {
      field: "turn",
      headerName: "Turn",
      hide: false,
      flex: 2,
    },
    {
      field: "number",
      headerName: "Number",
      hide: false,
      flex: 2,
    },
    {
      field: "date",
      headerName: "Date",
      hide: false,
      flex: 1.5,
      cellRenderer: (p) => {
        const date = p?.data?.date
          ? new Date(p.data?.date).toLocaleDateString()
          : "";
        return <div>{date}</div>;
      },
    },
    {
      field: "party",
      headerName: "Party",
      hide: false,
      flex: 2,
    },
    {
      field: "vehicleNumber",
      headerName: "Vehicle Number",
      hide: false,
      flex: 2,
    },

    // {
    //   headerName: "Action",
    //   field: "action",
    //   flex: 1.5,
    //   filter: false,
    //   headerClass: "center-header",
    //   cellStyle: {
    //     display: "flex",
    //     justifyContent: "center",
    //   },
    //   cellRenderer: (p) => (
    //     <CardDropdown>
    //       <div className="py-2">
    //         <Dropdown.Item
    //           // as={Link}
    //           onClick={() =>
    //             // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
    //             // () =>
    //             handleRowClick(p.data)
    //           }
    //           // href="/products/add-product"
    //           className="d-flex align-items-center gap-2 py-0"
    //         >
    //           <MdOutlineModeEdit />
    //           Edit
    //         </Dropdown.Item>
    //         {/* <Dropdown.Item
    //             // onClick={() => handleDelete()}
    //             className="d-flex align-items-center gap-2 py-0"
    //           >
    //             <MdDeleteOutline />
    //             Delete
    //           </Dropdown.Item> */}
    //       </div>
    //     </CardDropdown>
    //   ),
    // },
  ]);

  const handleRowClick = (data) => {
    if (data) {
      navigate(`${CONSTANT_ROUTES.WEIGHMENT_ADD}`, { state: data });
    }
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    // floatingFilter: true,
    // flex: 1,
    // rowDrag: true,
  };

  //   ===============Custom Api Call start================

  let gridApi;
  let columnApi;

  const onGridReady = useCallback(
    (e) => {
      gridApi = e.api;
      columnApi = e.columnApi;
      // CostCenterAPI.get().then((res) => {
      //   e.api.applyTransaction({ add: res?.data?.data });
      // });
    },
    [window]
  );

  const [rowData] = useState([
    {
      id: 1,
      turn: "Morning",
      number: "001",
      date: "2025-06-26T08:00:00Z",
      party: "Alpha Traders",
      vehicleNumber: "ABC-123",
    },
    {
      id: 2,
      turn: "Evening",
      number: "002",
      date: "2025-06-26T18:00:00Z",
      party: "Beta Logistics",
      vehicleNumber: "XYZ-789",
    },
    {
      id: 3,
      turn: "Night",
      number: "003",
      date: "2025-06-25T23:00:00Z",
      party: "Gamma Corp",
      vehicleNumber: "DEF-456",
    },
  ]);

  const onFilterTextBoxChanged = useCallback(() => {
    columnApiRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);

  return (
    <Modal
      size="xl"
      show={isOpenModal}
      onHide={handleClose}
      //   contentClassName="border"
    >
      <div>
        <Modal.Header closeButton className="bg-body-tertiary border-bottom-0">
          <Modal.Title as="h5">
            {from === "Second"
              ? "Weighments | Second Weight Entry"
              : "Weighments | Final Weight Entry"}
          </Modal.Title>
        </Modal.Header>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Button variant="falcon-default" size="sm" className="fs-10">
              Loading...
            </Button>
          </div>
        ) : (
          <Modal.Body className="p-2">
            <Form className="position-relative mb-2">
              <FontAwesomeIcon
                icon="search"
                className="position-absolute text-400 search-box-icon"
                style={{
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
              <Form.Control
                type="search"
                placeholder="Search..."
                style={{
                  paddingLeft: "30px",
                }}
                aria-label="Search"
                id="filter-text-box"
                className="rounded-pill search-input"
                onInput={onFilterTextBoxChanged}
              />
            </Form>
            <div
              className={`ag-theme-quartz rounded-0`}
              style={{ height: "400px", width: "100%" }}
            >
              <AgGridReact
                ref={columnApiRef}
                rowData={rowData}
                onGridReady={onGridReady}
                columnDefs={colDefs}
                headerHeight={35}
                rowHeight={35}
                defaultColDef={defaultColDef}
                // onRowDoubleClicked={(params) => handleRowClick(params.data)}
                overlayNoRowsTemplate="Nothing found - Looks empty over here"
              />
            </div>
          </Modal.Body>
        )}

        {/* <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
          <div onClick={handleClose} className="px-4 mx-0 cursor-pointer">
            Cancel
          </div>
          <Button variant="primary" type="submit" className="px-4 mx-0">
            Save
          </Button>
        </Modal.Footer> */}
      </div>
    </Modal>
  );
};

export default WeighmentEntryModal;
